module.exports = __webpack_public_path__ + "static/media/MovingBanner.ce2d5d0f.jpg";